import { DatabaseClientRepository } from "@domain/repositories/DatabaseClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { Paging } from "@domain/models/Paging";
import { userRoles } from "@domain/models/User";

type Input = Paging;

type Output = void;

export class WatchAllClientsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly databaseClientRepository: DatabaseClientRepository
  ) {}

  execute(paging: Input) {
    const user = this.userStore.user;

    if (user.role === userRoles.root || user.role === userRoles.admin) {
      this.databaseClientRepository.watchAllClientsAdmin(paging);
    }

    return;
  }
}
